import {
  useNumberFormatter,
  type useDateFormatter,
} from '@mint-lib/formatting-hooks';
import { isValid } from 'date-fns';

export const dataTableValueFormatter = (
  value: unknown,
  numberFormatter: ReturnType<typeof useNumberFormatter>,
  dateFormatter: ReturnType<typeof useDateFormatter>,
): string => {
  if (Number(value) === value) {
    const numericValue = numberFormatter.format(value, {
      options: { maxDecimals: 2 },
    })?.formatted;

    if (!numericValue) return '-';

    return numericValue;
  }

  if (typeof value === 'string') {
    // Check date values
    const dateValue = new Date(value);

    return isValid(dateValue) ? dateFormatter.formatDate(dateValue) : value;
  }

  return '-';
};
